import React, { useEffect, useState, useRef } from 'react'
import { AxiosError } from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import SpinnerLoader from 'src/app/components/commonComponents/SpinnerLoader';
import OtpInput from 'react-otp-input';
import { ErrorType, LoginStorageData } from 'src/shared/types/src';
import { OTP_LENGTH, LOGIN_OTP_TYPE, APP_MESSAGES } from 'src/shared/config/src';
import { verifyMFA, verifyOtp, sendVerificationCode } from 'src/shared/services/src';
import { getLoginStoreData } from 'src/shared/utils/src';
import { performAfterLogin } from 'src/shared/redux-state/src';
import { useAppDispatch, store } from 'src/app/services/store';
// import { useAppDispatch, store } from '@eyparent-web/services/store';
// import { performAfterLogin } from '@parent-app/redux-state';
// import { verifyMFA, verifyOtp } from '@parent-app/services';
// import { ErrorType, LoginStorageData } from '@parent-app/types';
// import { getLoginStoreData } from '@parent-app/utils';
// import { OTP_LENGTH } from '@parent-app/config';
import Images from '../../static'
import Footer from 'src/app/components/commonComponents/Footer';
import CustomButton from 'src/app/components/commonComponents/CustomButton';
import DownloadAppComponent from 'src/app/components/commonComponents/DownloadAppComponent';
import { AppRoutes } from 'src/app/navigation/routes';
import { RESEND_TIME, URL_CONSTANTS } from 'src/app/config/appConstants';
import { getRedirectionRoute } from 'src/app/utilities/helpers';
import { InfoModal } from 'src/app/components';

const FIELD_MAP = {
    OTP: 'otp'
};

const VerificationCodeScreen = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const buttonRef: any = useRef(null);
    const { email, isMFACall } = location.state || {};

    const [otpText, setOtpText] = useState<string>('');
    const [errors, setErrors] = useState<ErrorType>({});
    const [isVerifying, setIsVerifying] = useState<boolean>(false);
    const [resending, setResending] = useState<boolean>(false);
    const [sessionIdInState, setSessionId] = useState<string>(location.state && location.state.sessionId ? location.state.sessionId : '');
    const [countdown, setCountdown] = useState<number>(RESEND_TIME);
    const [infoModal, setInfoModal] = useState<boolean>(false);
    const [redirectionRoute, setRedirectionRoute] = useState<string>();

    useEffect(() => {
        if (!email){
            navigate(AppRoutes.VERIFY_EMAIL);
        }
        const redirectTo = getRedirectionRoute();
        if (redirectTo) {
            setRedirectionRoute(redirectTo);
        }
    }, [email])

    useEffect(() => {
        if(otpText && otpText.length === OTP_LENGTH){
            handleKeyDown({ key: "Enter" })
        }
    }, [otpText])

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);
        }
        return () => clearInterval(timer);
    }, [countdown]);

    const toggleInfoModal = () => setInfoModal(!infoModal);

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && buttonRef.current) {
            buttonRef.current.click();
        }
    };

    const runValidations = () => {
        let errorObj: ErrorType = {};
        if (!otpText) {
            errorObj = {
                ...errorObj,
                [FIELD_MAP.OTP]: {
                    isErrored: true,
                    errorMsg: `OTP cannot be blank`,
                },
            };
        } else if (otpText.length !== OTP_LENGTH) {
            errorObj = {
                ...errorObj,
                [FIELD_MAP.OTP]: {
                    isErrored: true,
                    errorMsg: `OTP is invalid`,
                },
            };
        }
        setErrors(errorObj);

        if (Object.keys(errorObj).length) return false;
        else return true;
    }

    const handleVerifyOtp = async () => {
        if (isVerifying) return;

        const validity = runValidations();
        if (!validity) return;

        setIsVerifying(true);

        try {
            if (isMFACall) {
                const response = await verifyMFA({ email, sessionId: sessionIdInState, otp: otpText });
                if (response && Object.keys(response).length > 0) {
                    // set login states 
                    const dataToStore: LoginStorageData | undefined = getLoginStoreData(response);
                    if (dataToStore) {
                        await dispatch(performAfterLogin({ dataToStore, reduxStore: store }));
                        dataToStore.termsAccepted ? 
                            (redirectionRoute ? navigate(redirectionRoute) : navigate(AppRoutes.HOME)) : 
                            navigate(`${AppRoutes.TERMS_CONDITIONS}${redirectionRoute ? `?${URL_CONSTANTS.REDIRECT_TO}=${redirectionRoute}` : ''}`);
                    }
                }
            } else {
                const response = await verifyOtp({ email, sessionId: sessionIdInState, otp: otpText });
                if (response && Object.keys(response).length > 0) {
                    navigate(`${AppRoutes.VERIFY_DOB}${redirectionRoute ? `?${URL_CONSTANTS.REDIRECT_TO}=${redirectionRoute}` : ''}`, { state: { email, sessionId: sessionIdInState, label: response.label, otp: otpText }});
                }
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                const apiError = error as AxiosError;
                if (apiError && apiError.response) {
                    const { errors } = error.response?.data;
                    toast.error(errors.join(", "), { autoClose: 5000 });
                } else {
                    toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
                }
            }
        } finally {
            setIsVerifying(false);
        }
    }

    const handleAccountVerification = async () => {
        if (resending) return;
        setErrors({});
        setOtpText('')
        try {
            setResending(true);
            const { sessionId } = await sendVerificationCode({ email, type: isMFACall ? LOGIN_OTP_TYPE.LOGIN : LOGIN_OTP_TYPE.ACTIVATION, sessionId: sessionIdInState });
            if (sessionId) {
                toast.success('Verification code sent successfully', { autoClose: 5000 });
                setSessionId(sessionId);
                setCountdown(RESEND_TIME);
            } else {
                toast.error("Could not send verification code.", { autoClose: 5000 });
            }
        } catch (error) {
            console.log("error from send otp : ", error);
            if (error instanceof AxiosError) {
                const apiError = error as AxiosError;
                console.log("error  : ", error.response);
                if (apiError && apiError.response) {
                    const { errors } = error.response?.data;
                    toast.error(errors.join(", "), { autoClose: 5000 });
                } else {
                    toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
                }
            }
        } finally {
            setResending(false);
        }
    }

    const infoPopupHTML = () => (
        <div className='info-modal-body'>
            <h2>In case you have not received your OTP :</h2>
            <ul>
                <li>Ensure your email is entered correctly.</li>
                <li>Check your spam/junk folder for an email with subject 'Your eyparent Sign-In Verification Code'.</li>
                <li>You can try requesting a new OTP from 'Resend' option above.</li>
            </ul>
        </div>
    )

    return (
        <div className='main-wrapper bg-white container'>
            <div className='d-flex flex-column flex-grow-1 mg-b-20'>
                <div className='mg-b-78 mg-t-xxl-100 mg-t-xs-50 pd-t-md-30 pd-t-xs-0 d-flex justify-content-center align-items-center'>
                    <img src={Images.logo} alt="logo" className="eyworks-logo" />
                </div>
                <p className='fs-4 text-black fw-bold'>Verify Account</p>
                <p className='fs-14 text-black mg-b-28'>Please enter the 6 digit verification code sent to your email address.</p>
                <div className='mg-b-25 form-group'>
                    <div className='position-relative'>
                        <label className='form-label fs-12'>Verification Code</label>
                        {countdown > 0 ? 
                            <label className='position-absolute top-0 end-0 form-label fs-12'>Resend in {`00:${countdown.toString().padStart(2, '0')}`}</label> :
                            <CustomButton 
                                text={'Resend'} 
                                onClick={handleAccountVerification} 
                                isLoading={resending} color={'link'} 
                                customBtnStyle={'custom-btn-link-with-underline position-absolute top-0 end-0'} 
                                customSpinnerStyle={'spinner-border-xsm'} 
                            />
                        }
                    </div>
                    <OtpInput
                        shouldAutoFocus={true}
                        value={otpText}
                        onChange={setOtpText}
                        numInputs={6}
                        inputType="tel"
                        renderInput={(props, index) => <input 
                                {...props} 
                                className="form-control form-control-otp-input" 
                                onKeyDown={(e) => {
                                    if (!((e.key >= "0" && e.key <= "9") || ["Backspace", "Delete", "Enter"].includes(e.key) || (e.key === 'v' && (e.ctrlKey || e.metaKey)))) {
                                        e.preventDefault();
                                    } else if (e.key === "Backspace" && !props.value) {
                                        const prevInput: any = document.querySelector(
                                            `.form-control-otp-input:nth-child(${index})`
                                        );
                                        if (prevInput) {
                                            prevInput.focus();
                                        }
                                    }else {
                                        handleKeyDown(e);
                                    }
                                }}
                            />
                        }
                    />
                    <p className='form-label fs-12 mg-t-5 mb-0'>This code is valid for next 30 minutes</p>
                    {errors && errors[FIELD_MAP.OTP] && errors[FIELD_MAP.OTP].isErrored ? <span className="form-error">{errors[FIELD_MAP.OTP].errorMsg}</span> : null}
                </div>
                <CustomButton text={"Didn't receive the code?"} onClick={toggleInfoModal} color={'link'} customBtnStyle='custom-btn-link-with-underline mb-20' />
                <CustomButton text={isMFACall ? 'Submit' : 'Next'} onClick={handleVerifyOtp} isLoading={isVerifying} color={'primary'} buttonRef={buttonRef} />
            </div>
            <div className='mg-b-10'>
                <InfoModal
                    isInfoModal={infoModal}
                    toggleInfoModal={toggleInfoModal}
                    informationHtml={infoPopupHTML}
                    popupMinHeight={'auto'}
                    modalHeader={"Didn't receive OTP?"}
                    customModalHeaderStyle='info-modal-header'
                />
                <DownloadAppComponent />
                <Footer />
            </div>
        </div>
    )
}

export default VerificationCodeScreen;